<template>
  <div :bordered='false'>
    <div class='table-page-search-wrapper'>

      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='12'>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="'Phone'">
              <a-input v-model='queryParam.mobileNo'></a-input>
            </a-form-item>
          </a-col>

          <a-col :md='6' :sm='8'>
            <a-form-item :label="'ProductType'">
              <a-select
                v-model='queryParam.appSsid'
              >
                <a-select-option v-for='item in appList' :key='item.appssid'>
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md='6' :sm='8'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
              <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset')
                }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>

      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :rowClassName='rowClassName'
        :pagination='false'
        :loading='loading'
        bordered>
      </a-table>

    </div>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getApplist } from '@/webpublicapi/order'
import Dict from '../modules/Dict'
import DictSelect from '../modules/DictSelect'
import moment from 'moment'
import vModal from '../modules/Modal'
import { getRiskOperationInfo } from '@/webpublicapi/customer'

const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  COLLECTION: 'collection.',
  OPERATION: 'operation.'
}

export default {
  name: 'RiskPointinfo',
  components: {
    Dict,
    DictSelect,
    vModal
  },
  data() {
    return {
      visdialog: false,
      I18N_KEY,
      toggleSearchStatus: false,
      visible: false,
      // Pagination params
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      appList: [],
      // Query conditions
      queryParam: {
        'appSsid': '',
        'mobileNo': ''
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: 'Event Name',
          align: 'left',
          dataIndex: 'optType'
        },
        {
          title: 'gaid',
          align: 'left',
          dataIndex: 'gaid'
        },
        {
          title: 'Latitude',
          align: 'left',
          dataIndex: 'lbs'
        },
        {
          title: 'Page',
          align: 'left',
          dataIndex: 'extVarchar1'
        },
        {
          title: 'Created Time',
          align: 'left',
          dataIndex: 'createTime'
        }
      ]
    }
  },
  created() {
    getApplist().then(res => {
      this.appList = res.data || []
      if (this.appList != null) {
        this.appList.forEach(item => {
          if (item.appName == 'All') {
            item.appName = 'Please select'
          }
        })
      }
    })
    this.getDict()
  },
  methods: {
    searchQuery() {
      this.loadData()
    },
    loadData() {
      this.loading = true
      var mobileNo = this.queryParam.mobileNo
      var appSsid = this.queryParam.appSsid
      this.dataSource = []
      getRiskOperationInfo(mobileNo, appSsid).then((res) => {
        if (res.code === 1000) {
          this.dataSource = res.data || []
          if (this.dataSource != null) {
            // 1, personal info,2, work info,3, contact info,4, ID info,5, collection info
            this.dataSource.forEach(item => {
              if (item.extVarchar1 == 0) {
                item.extVarchar1 = 'No'
              } else if (item.extVarchar1 == 1) {
                item.extVarchar1 = 'Personal Info'
              } else if (item.extVarchar1 == 2) {
                item.extVarchar1 = 'WorkInfo'
              } else if (item.extVarchar1 == 3) {
                item.extVarchar1 = 'ContactInfo'
              } else if (item.extVarchar1 == 4) {
                item.extVarchar1 = 'IdentityInfo'
              } else if (item.extVarchar1 == 5) {
                item.extVarchar1 = 'Collection Info'
              }
            })
          }
        } else {
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
      }).catch(e => {
        this.$message.error(e.message)
      })
      this.loading = false
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformTimeSecond(time) {
      return moment(time).format('YYYY-MM-DD HH:mm:ss')
    },

    // Reset dictionary type search box content
    searchReset() {
      var that = this
      that.queryParam.appSsid = 'Please select'
      that.queryParam.mobileNo = undefined
      that.dataSource = []
    },

    rowClassName(record, index) {
      var date = new Date(record.curDate)
      var day = date.getTime() / 24 / 60 / 60 / 1000 + 3

      if ((day % 7) + 1 == 7) {
        return 'table_weekendColor'
      }
      return ''
    }

  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>
